const PATH =
  'M7 4h10a2 2 0 0 1 2 2v2h1a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h1V6a2 2 0 0 1 2-2zm-1 15h2v1.5H6zm10 0h2v1.5h-2z';

/** A sofa silhouette sized to 1em and painted in the current text colour —
 *  the house sits in the living room, so the mark shows the couch. */
export function CouchIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d={PATH} />
    </svg>
  );
}
